import { render, staticRenderFns } from "./FavouriteAddress.vue?vue&type=template&id=0939e988&"
import script from "./FavouriteAddress.vue?vue&type=script&lang=js&"
export * from "./FavouriteAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports